import type { CustomerOrderStatus } from '@scan2eat/shared';

import { labels } from '../labels.js';
import { Icon, type IconName } from './Icon.js';
import styles from './OrderStatusTimeline.module.css';

const STEPS = ['PENDING', 'PREPARING', 'READY', 'SERVED'] as const;

const STEP_ICON: Record<(typeof STEPS)[number], IconName> = {
  PENDING: 'receipt',
  PREPARING: 'utensils',
  READY: 'bag',
  SERVED: 'check',
};

/**
 * Four fixed steps matching customerStatus. docs/15, section 3.4.
 * ON_HOLD reaches the diner as PREPARING: "on hold" would worry someone who is
 * already waiting.
 */
export function OrderStatusTimeline({ status }: { status: CustomerOrderStatus }) {
  const current = STEPS.indexOf(status as (typeof STEPS)[number]);

  return (
    <ol className={styles.timeline} style={{ '--progress': `${Math.max(0, current) / (STEPS.length - 1)}` } as React.CSSProperties}>
      {STEPS.map((step, i) => {
        const state = i < current ? 'done' : i === current ? 'current' : 'todo';
        return (
          <li key={step} className={`${styles.step} ${styles[state]}`} aria-current={state === 'current' ? 'step' : undefined}>
            <span className={styles.dot}>
              <Icon name={state === 'done' ? 'check' : STEP_ICON[step]} size={18} />
            </span>
            <span className={styles.label}>{labels.customerStatus[step]}</span>
          </li>
        );
      })}
    </ol>
  );
}
